import React, { useEffect, useState } from 'react';

export default () => {

    useEffect(() => {

        document.title = "NSTRUCT";
        const lang = navigator.language || navigator.userLanguage;
        
        if( (String(lang).startsWith('ko')) ){
            document.location.href='/kr'
        }else if( (String(lang).startsWith('ja')) ){
            document.location.href='/jp'
        }else{
            document.location.href='/en'
        }


      }, []);


    return(
        <div >
        </div>
    );

}